module.exports = __webpack_public_path__ + "static/media/IncreasingPositiveAttitude.99f3e67b.mp3";